import AddIcon from '@mui/icons-material/Add';
import BarChartIcon from '@mui/icons-material/BarChart';
import HistoryIcon from '@mui/icons-material/History';
// import SearchIcon from '@mui/icons-material/Search';
import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import {
  getMassMailingCredsPerDay,
  getTotalMailingCreditsAllotted,
  IVendorSearchFilterDTO,
} from 'wisestep-api';
import {
  WsListingLoader,
  WsCard,
  CardVariant,
  WsButton,
  ScrollableTabs,
  TabTextVariant,
} from 'wisestep-base';

import { ActivateFeature } from '../../../components/ActivateFeature';
import NoDataFoundCard from '../../../components/noDataFoundCard';
import NoCandidateIcon from '../../../images/NoCandidate.svg';
import useConsultantsStore from '../../importConsultants/listing/hooks/useConsultantsStore';
import useJobsStore from '../../jobs/listing/hooks/useJobsStore';
import useAllvendorsSearch from '../hooks/useAllVendorsSearch';
import { Credits, vendorsSearchDefaultQuery } from '../utils/vendorsHelper';

import SelectedJobCard from './selectedJobCard/SelectedJobCard';
import VendorTopBanner from './topBanner/VendorsTopBanner';
import VendorsListTable from './vendorsListTable/VendorsListTable';

const AllVendorsListing = () => {
  const [loader, setLoader] = useState<boolean>(false);
  const [query, setQuery] = useState<IVendorSearchFilterDTO>(vendorsSearchDefaultQuery);
  query.emailBounceStatus = null;
  const vendorsByLists = useAllvendorsSearch(query, setLoader);
  const navigate = useNavigate();
  const [tabPanelPage, setTabPanelPage] = useState(0);
  const selectedJobs = useJobsStore((state) => state.jobs);
  const unSelectJob = useJobsStore((state) => state.removeSelectedJob);
  const selectedConsultants = useConsultantsStore((state) => state.consultants);
  const unSelectConsultants = useConsultantsStore((state) => state.removeSelectedConsultant);
  const [credits, setCredits] = useState<Credits>({ balance: 0, used: 0 });
  const [allotedCredits, setAllotedCredits] = useState<number>(0);
  const GetMassMailingCreds = async () => {
    const response = await getMassMailingCredsPerDay();
    setCredits({ balance: response.data[0]['balance'], used: response.data[0]['used'] });
  };

  const GetTotalMailingCreditsAllotted = async () => {
    const allotedRes = await getTotalMailingCreditsAllotted();
    setAllotedCredits(allotedRes.data['totalAllottedInWorkspace']);
  };
  useEffect(() => {
    const fetchCredits = async () => {
      GetMassMailingCreds();
      GetTotalMailingCreditsAllotted();
    };
    fetchCredits();
  }, []);
  const pageRefersh = () => {
    GetMassMailingCreds();
    GetTotalMailingCreditsAllotted();
    setQuery({ ...query });
  };
  const methods = useForm();
  // const search = () => {
  //   query.query = methods.watch('search');
  //   setQuery({ ...query });
  // };
  return (
    <FormProvider {...methods}>
      <Grid container spacing={1}>
        <Grid item xs={12} pb={2}>
          <VendorTopBanner
            credits={credits}
            allotedCredits={allotedCredits}
            pageRefresh={pageRefersh}
          />
        </Grid>
        {selectedJobs.length > 0 && (
          <Grid item xs={12} container pb={2} gap={1}>
            {selectedJobs.map((job, index) => (
              <SelectedJobCard key={index} job={job} OnRemoveJob={() => unSelectJob(job)} />
            ))}
          </Grid>
        )}
        {selectedConsultants.length > 0 && (
          <Grid item xs={12} container pb={2} gap={1}>
            {selectedConsultants.map((consultant, index) => (
              <SelectedJobCard
                key={index}
                consultant={consultant}
                OnRemoveJob={() => unSelectConsultants(consultant)}
              />
            ))}
          </Grid>
        )}
        <Grid item xs={12}>
          {vendorsByLists.totalRecords > 0 && !loader ? (
            <Box>
              <Grid item xs={12} display="flex" justifyContent="flex-end" columnGap={2}>
                <ActivateFeature feature="VS_VIEW_BROADCAST_HISTORY">
                  <WsButton
                    variant="text"
                    startIcon={<HistoryIcon />}
                    onClick={() => navigate('/vendors/broadcast-history')}
                  >
                    View History
                  </WsButton>
                </ActivateFeature>
                <WsButton variant="outlined" startIcon={<BarChartIcon />}>
                  Analytics
                </WsButton>

                <ActivateFeature feature="VS_CREATE_VENDORS">
                  <WsButton
                    variant="contained"
                    onClick={() => navigate('/vendors/new-vendor-list')}
                    startIcon={<AddIcon />}
                  >
                    Import Vendors
                  </WsButton>
                </ActivateFeature>
              </Grid>
              <Grid item xs={12} container>
                <Grid item xs={6}>
                  <ScrollableTabs
                    variant={TabTextVariant.SUB_TITLE}
                    scrollList={[{ tabName: 'All Lists' }, { tabName: 'My Lists' }]}
                    getTabIndex={(index: number) => setTabPanelPage(index)}
                  />
                </Grid>
                {/* <Grid
                  item
                  xs={6}
                  container
                  bgcolor={WsColors.White}
                  alignItems="center"
                  borderRadius={2}
                >
                  <Grid item xs={10} bgcolor={WsColors.White}>
                    <SearchBar
                      name="search"
                      placeholder="Search by vendor list name, Email and status"
                    />
                  </Grid>
                  <WsButton
                    variant="outlined"
                    size="small"
                    onClick={() => search()}
                    startIcon={<SearchIcon />}
                  >
                    Search
                  </WsButton>
                </Grid> */}
              </Grid>

              {tabPanelPage === 0 && (
                <VendorsListTable
                  data={vendorsByLists}
                  pageRefresh={pageRefersh}
                  creditsBalance={credits.balance - allotedCredits}
                />
              )}
              {tabPanelPage === 1 && <NoDataFoundCard text="No Vendors Found" />}
            </Box>
          ) : loader ? (
            <WsListingLoader />
          ) : (
            <WsCard
              title="There are no Vendor Lists"
              description="Upload Vendor Lists to your workspace"
              middleComponent={<img src={NoCandidateIcon} alt="NoCandidates" />}
              onClick={() => navigate('/vendors/new-vendor-list')}
              isButton={false}
              buttonText="+ Import Vendors"
              cardType={CardVariant.WITH_LIGHT_BG}
            />
          )}
        </Grid>
      </Grid>
    </FormProvider>
  );
};
export default AllVendorsListing;
